import React from "react";
import "./Marquee.css"; // Ensure this file is in the same directory or adjust the path

const Marquee = () => {
  return (
    <div className="marquee-wrapper">
      <div className="marquee-container-custom">
        <div className="marquee-text-custom">
          நம் நெல்லையில்  MKM தங்க மாளிகை!  இன்றைய தங்க விலை கிராம் ஒன்றிற்கு 24k- Rs.7773, 22k- Rs.7125, 18k-5830, வெள்ளி கிராம் ஒன்றிற்கு Rs.100/-
        </div>
      </div>
    </div>
  );
};

export default Marquee;
